import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate,
} from "@tanstack/react-router"
import {clsx} from "@/utils/clsx"
import styles from "./profile.module.scss"
import {Tabs} from "@/components/ui/Tabs/Tabs"
import {GoChevronLeft} from "react-icons/go"
import {profileNavigationItems} from "@/common/const/profile/navigation.const.profile"
import {MobileProfileButton} from "@/components/profile/MobileProfileButton/MobileProfileButton.tsx"
import {useAppContext} from "@/context/AppContext.tsx"
import { useTranslation } from "react-i18next"

export const Route = createFileRoute("/_mainLayout/profile")({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation("page")

  const {isMobile} = useAppContext()

  function goBack() {
    if (window.history.length > 1) {
      window.history.back()
    } else {
      navigate({to: "/"})
    }
  }

  return (
    <div className={clsx(styles.profile)}>
      {location.pathname !== "/profile" && (
        <button onClick={goBack} className={styles.back}>
          <GoChevronLeft/>
          {!isMobile && t('back')}
        </button>
      )}
      {/*use location to not show menu on 'menu page'*/}
      {(isMobile && location.pathname !== '/profile/mobileMenu') && <MobileProfileButton/> }
      <Tabs
        items={profileNavigationItems.map(item => ({
          label: t(`tabs.${item.key.toLowerCase()}`),
          ...item,
        }))}
        className={clsx(styles.desktop)}
      />
      <Outlet/>
    </div>
  )
}
